<template>
  <li class="news-list-item van-hairline--bottom">
    <div class="news-list-item__left"></div>
    <div class="news-list-item__right">
      <p class="news-list-item__right__title van-multi-ellipsis--l3">这里是标题内容长标题这里是标题内容长标题这里是标题内容长标题这里是标题内容长标题这里是标题内容长标题</p>
      <ul class="news-list-item__right__desc">
        <li><van-icon name="user-circle-o" class="anthor" /><span>运营官方</span></li>
        <li>2020-0205</li>
      </ul>
    </div>
  </li>
</template>

<script>
export default {
  name: 'NewsListItem'
}
</script>

<style lang="scss" scoped>
.news-list-item {
  display: flex;
  padding: 16px;
  &__left {
    width: 30%;
    height: 90px;
    background-color:#39a9ed;
    margin-right: 10px;
  }
  &__right {
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    li:first-child {
      .anthor {
        margin-right: 2px;
      }
    }
    &__title {
      font-size: 14px;
      font-weight: bold;
      margin-top: 2px;
      color: #333;
    }
    &__desc {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #666;
    }
  }
}
</style>
